import { GoogleMap, InfoWindowF, LoadScript, Marker } from "@react-google-maps/api";
import { Button, Input, message, Modal, Select, Switch, Tooltip } from 'antd';
import { FC, ReactElement, ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EditInfos } from "../components/editinfos";
import { LayoutSite } from '../components/layout';
import { Loader } from '../components/loader';
import { useKeys } from '../keys';
import { useLocalStorage } from "../localstorage";
import { addkeys, csvtokml, kmltocsv } from '../services/api.service';
import { APIAnswerData, JumpInfos, JUMPS, JumpType, TrackInfos, TrackPoint } from '../types';
import './edittrack.scss';

const API_KEY = 'AIzaSyAYJ0T0QfMpPex9whIoratlZIIiEaJXAq8';

const MAP_CENTER = { lat: 43.628908, lng: 3.909600 };
const MAP_STYLE = { width: "100%", height: "100%" };
const MAP_ZOOM = 16;

const MAP_OPTIONS = {
    streetViewControl: false,
    mapTypeId: 'satellite',
    scaleControl: true,
    fullscreenControl: true,
    fullscreenControlOptions: { position: 6.0},
    gestureHandling: "greedy",
    disableDoubleClickZoom: true,
    minZoom: 3,
    maxZoom: 20,
    mapTypeControl: false,
    zoomControl: true,
    clickableIcons: false,
    disableDefaultUI: true
};
/* -------------------------------------------------------------------------------- *\
|                               EditTrackPage
\* -------------------------------------------------------------------------------- */
export const EditTrackPage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [map, setMap] = useState<google.maps.Map | null>(null);

    const [currentcsv, setCurrentCsv] = useState<string>("");

    const [tempfile, setTempFile] = useState<string>('');
    const [dlgkmltocsvvisible, setDlgkmltocsvvisible] = useState(false);
    const [dlgjumpvisible, setDlgjumpvisible] = useState(false);

    const [lastuploadfile, setlastuploadfile] = useLocalStorage('lastuploadfile', '');
    const [uploadfile, setUploadFile] = useState<string>(lastuploadfile);
    const [loadmode, setLoadMode] = useState<string>("csv");
    const [showfile, setShowFile] = useState(true);

    const [mappoints, setMapPoints] = useState<TrackPoint[]>([]);
    const [jumpsinfos, setJumpsInfos] = useState<JumpInfos[]>([]);
    const [markers_int, setMarkers_int] = useState<ReactElement[]>([]);
    const [markers_mid, setMarkers_mid] = useState<ReactElement[]>([]);
    const [markers_ext, setMarkers_ext] = useState<ReactElement[]>([]);
    const [maplines, setMapLines] = useState<google.maps.Polyline[]>([]);
    const [trackinfos, setTrackInfos] = useState<TrackInfos | null>(null);
    
    const [mappc, setMapPC] = useState<TrackPoint[]>([]);
    const [selectedpc, setSelectedPC] = useState<TrackPoint>();
    const [markers_selpc, setMarkersSelectedPC] = useState<ReactElement[]>([]);

    const [showgate, setShowGate] = useState<boolean>(false);
    const [showobstacle, setShowObstacle] = useState<boolean>(false);
    const [showyards, setShowYards] = useState<boolean>(false);
    const [showmids, setShowMids] = useState<boolean>(false);
    const [follow, setFollow] = useState<boolean>(true);

    const [last_edit_corde, setlast_edit_corde] = useLocalStorage('last_edit_corde', 'droite');
    const [edit_corde, setEditCorde] = useState<string>(last_edit_corde);
    const [last_edit_width, setlast_edit_width] = useLocalStorage('last_edit_width', '30');
    const [edit_width, setEditWidth] = useState<number>(Number(last_edit_width) ? Number(last_edit_width) : 30);
    const [last_edit_pcdep, setlast_edit_pcdep] = useLocalStorage('last_edit_pcdep', '1400');
    const [edit_pcdep, setEditPCDep] = useState<number>(Number(last_edit_pcdep) ? Number(last_edit_pcdep) : 30);
    const [edit_distance, setEditDistance] = useState<number>(1000);
    const [edit_jump, setEditJump] = useState<JumpType>(JUMPS[0]);
    const [selectedit_jump, setSelectEditJump] = useState<JumpInfos | null>(null);

    /* -------------------------------------------------------------------------------- *\
    |                               scrollToItem
    \* -------------------------------------------------------------------------------- */
    const scrollToItem = (id: string) =>
    {
        const element = document.getElementById(id);
        if (element)
        {
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };
    /* -------------------------------------------------------------------------------- *\
    |                               onKeyDown
    \* -------------------------------------------------------------------------------- */
    const onKeyDown = (event) => 
    {
        if (selectedpc)
        {
            var i = mappc.indexOf(selectedpc);
            if (event.key === 'ArrowUp')
            {
                if (i > 0)
                {
                    scrollToItem('mappc_' + (i - 1));
                    doselectpc(mappc[i - 1]);
                }
            }
            else if (event.key === 'ArrowDown')
            {
                if (i < mappc.length - 1)
                {
                    scrollToItem('mappc_' + (i + 1));
                    doselectpc(mappc[i + 1]);
                }
            }
            event.preventDefault();
        }
    }
    const onKeyUp = () => {};

    useKeys(onKeyDown, onKeyUp, ['ArrowDown', 'ArrowUp']);

    /* -------------------------------------------------------------------------------- *\
    |                               doselectpc
    \* -------------------------------------------------------------------------------- */
    function doselectpc(pc: TrackPoint)
    {
        setSelectedPC(pc);
        const j = jumpsinfos.find((jump: JumpInfos) => pc.extra === ("PCO" + String(jump.number).padStart(2, '0') + jump.key + String(jump.distance)));
        if (j)
        {
            setSelectEditJump(j);
        }
        else
        {
            setSelectEditJump(null);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               decodecsv
    \* -------------------------------------------------------------------------------- */
    function decodecsv(content: string)
    {
        const lines: string[] = content.replace(/\r/g, '').split('\n');
        var errors: string[] = [];
        var first: boolean = true;
        for(const line of lines)
        {
            const els: string[] = line.split(';');
            if (first)
            {
                if (els.length !== 8)
                {
                    errors.push("Line " + (lines.indexOf(line) + 1) + " must have 8 elements");
                }
                if (!els[0].toLocaleUpperCase().startsWith("DIST"))
                {
                    errors.push("Line " + (lines.indexOf(line) + 1) + " must start with DIST");
                }
                if (errors.length > 0) break;
                first = false;
            }
            if (els.length > 1 && els.length !== 8)
            {
                errors.push("Line " + (lines.indexOf(line) + 1) + " must have 8 elements");
            }
            if (errors.length > 5)
            {
                errors.push("Too many errors");
                break;
            }
        }
        let final = "";
        if (errors.length > 0)
        {
            setlastuploadfile("");
            for(const error of errors)
            {
                message.error(error);
            }
        }
        else
        {
            setlastuploadfile(content);
            final = content;
        }
        
        setUploadFile("");
        setShowFile(false);
        setTimeout(() => { setUploadFile(final); setShowFile(true); }, 100);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               handleuploadfile
    \* -------------------------------------------------------------------------------- */
    function handleuploadfile(files: FileList)
    {
        if (files && files[0])
        {
            const f: File = files[0];

            var reader = new FileReader();
            reader.addEventListener('load', (e) =>
            {
                if (e.loaded === e.total && e.target)
                {
                    const content: string = e.target.result as string;
                    if (loadmode === 'csv')
                    {
                        decodecsv(content);
                    }
                    if (loadmode === 'kml')
                    {
                        setTempFile(content);
                    }
                    if (loadmode === 'jumps')
                    {
                        setJumps(content);
                    }
                }
            });
            reader.readAsText(f as Blob);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               changeselectedjump
    \* -------------------------------------------------------------------------------- */
    function changeselectedjump(jump: JumpInfos)
    {
        const t: string = "PCO" + String(jump.number).padStart(2, '0') + jump.key + String(jump.distance);
        const f = mappc.find((p: TrackPoint) => p.extra === t);
        doselectpc(f ? f : new TrackPoint());
    }
    /* -------------------------------------------------------------------------------- *\
    |                               changetrack
    \* -------------------------------------------------------------------------------- */
    function changetrack()
    {
        setMarkers_int([]);
        setMarkers_mid([]);
        setMarkers_ext([]);
        setMapPC([]);
        setMarkersSelectedPC([]);
        setJumpsInfos([]);

        for(const pl of maplines)
        {
            pl.setMap(null);
        }
        setMapLines([]);
        if (uploadfile)
        {
            try
            {
                const content = uploadfile;
                var points: TrackPoint []= [];
                var infos: TrackInfos = new TrackInfos();
                var jumps: JumpInfos[] = [];

                const lines = content.replace(/\r/g, '').split("\n");
                var first: boolean = true;
                for (const line of lines)
                {
                    if (!first && line)
                    {
                        const els = line.split(";");
                        if (els.length >= 8)
                        {
                            const pt: TrackPoint = new TrackPoint();
                            pt.distance = parseFloat(els[0]);
                            pt.lat_int = parseFloat(els[1]);
                            pt.lon_int = parseFloat(els[2]);
                            pt.lat_mid = parseFloat(els[3]);
                            pt.lon_mid = parseFloat(els[4]);
                            pt.lat_ext = parseFloat(els[5]);
                            pt.lon_ext = parseFloat(els[6]);
                            pt.extra = els[7].trim();
                            if (pt.extra === '0') pt.extra = '';
                            
                            points.push(pt);
                            
                            if (pt.extra === 'PCDEP') infos.dist_pcdep = pt.distance;
                            infos.dist_total = pt.distance;

                            if (pt.extra.startsWith('PY'))
                            {
                                infos.withyards = true;
                            }
                            
                            if (pt.extra.startsWith('PCO'))
                            {
                                infos.jumps.push(pt);

                                const no: number = parseInt(pt.extra.substring(3, 5));
                                const key: string = pt.extra.substring(5, 9);
                                const dist: number = parseInt(pt.extra.substring(9));
                                
                                var jump: JumpInfos = new JumpInfos();
                                jump.distance = dist;
                                jump.key = key;
                                jump.number = no;
                                jump.position = pt;

                                const fj = JUMPS.find(j => j.key === key);
                                if (fj)
                                {
                                    jump.text = fj.text;
                                }

                                jumps.push(jump);
                            }
                        }
                    }
                    first = false;
                }
                if (points.length > 0)
                {
                    const center_lat = points.reduce((sum, p) => sum + p.lat_int, 0) / points.length;
                    const center_lon = points.reduce((sum, p) => sum + p.lon_int, 0) / points.length;

                    setCenter({ lat: center_lat, lng: center_lon });
                }

                for (let jump of jumps)
                {
                    const fpcs = points.find((p: TrackPoint) => p.extra.startsWith('PCS' + String(jump.number).padStart(2, '0')));
                    if (fpcs)
                    {
                        jump.pcs = fpcs;
                    }
                    const fpca = points.find((p: TrackPoint) => p.extra.startsWith('PCA' + String(jump.number).padStart(2, '0')));
                    if (fpca)
                    {
                        jump.pca = fpca;
                    }
                }

                setMapPoints(points);
                setMapPC(points.filter(n => n.extra).reverse());
                setTrackInfos(infos);
                setJumpsInfos(jumps.reverse());
                setCurrentCsv(content);
            }
            catch (error: any)
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            };
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               getcsv
    \* -------------------------------------------------------------------------------- */
    function getcsv()
    {
        if (currentcsv)
        {
            const url = window.URL.createObjectURL(new Blob([currentcsv]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `track.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               getkml
    \* -------------------------------------------------------------------------------- */
    function getkml()
    {
        if (currentcsv)
        {
            csvtokml(currentcsv)
            .then((answer: APIAnswerData) => 
            {
                if (answer.status)
                {
                    const url = window.URL.createObjectURL(new Blob([answer.data.kml]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `track.kml`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
                else
                {
                    if (answer.data && answer.data.stdout) message.error(<pre style={{margin:0, whiteSpace:'pre-wrap', textAlign:'left'}}>{answer.data.stdout.join('\n')}</pre>);
                }
            })
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            });
        }
    }
    type JumpSave = { type: string, distance: number };
    /* -------------------------------------------------------------------------------- *\
    |                               computejumpsave
    \* -------------------------------------------------------------------------------- */
    function computejumpsave()
    {
        const jumps: JumpSave[] = [];
        for(const ji of jumpsinfos)
        {
            jumps.push({ type: ji.key, distance: ji.distance });
        }
        return jumps;        
    }
    /* -------------------------------------------------------------------------------- *\
    |                               getjumps
    \* -------------------------------------------------------------------------------- */
    function getjumps()
    {
        if (currentcsv)
        {
            const jumps: JumpSave[] = computejumpsave();
            const url = window.URL.createObjectURL(new Blob([JSON.stringify(jumps, null, 2)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `jumps.kml`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               setJumps
    \* -------------------------------------------------------------------------------- */
    function setJumps(newcontent: string)
    {
        if (currentcsv)
        {
            let distance: number = 0;
            let content: string = currentcsv;
            const lines = content.replace(/\r/g, '').split("\n");
            var first: boolean = true;
            const newlines: string[] = [];
            for (const line of lines)
            {
                if (!line) continue;
                if (!first)
                {
                    const els = line.split(";");
                    if (els.length >= 8)
                    {
                        if (els[7].startsWith("PCO")) continue;
                        if (els[7] !== 'PCARR' && (els[7].startsWith("PCS") || els[7].startsWith("PCA")))
                        {
                            els[7] = '0';
                        }
                        newlines.push(els.join(";"));
                        if (els[7] === 'PCDEP') distance = Number(els[0]);
                    }
                }
                if (first) newlines.push(line);
                first = false;
            }
            const jumps: JumpSave[] = JSON.parse(newcontent);
            computejumps(newlines.join("\n"), distance, jumps);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               loadcsv
    \* -------------------------------------------------------------------------------- */
    function loadcsv()
    {
        setLoadMode('csv');
        const button = document.getElementById('inputfile');
        if (button) button.click();
    }
    /* -------------------------------------------------------------------------------- *\
    |                               loadkml
    \* -------------------------------------------------------------------------------- */
    function loadkml()
    {
        setTempFile('');
        setLoadMode('kml');
        setDlgkmltocsvvisible(true);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               loadjumps
    \* -------------------------------------------------------------------------------- */
    function loadjumps()
    {
        setLoadMode('jumps');
        const button = document.getElementById('inputfile');
        if (button) button.click();
    }
    /* -------------------------------------------------------------------------------- *\
    |                               dlgeditvenueclose
    \* -------------------------------------------------------------------------------- */
    function dlgeditvenueclose(save: boolean)
    {
        if (save)
        {
            if (!tempfile)
            {
                message.error("You must choose a file to upload");
                return;
            }
            if (edit_width <= 2)
            {
                message.error("Width must be greater than 2");
                return;
            }
            if (edit_pcdep !== 0 && edit_pcdep <= 50)
            {
                message.error("PCDep must be greater than 50 or 0 for automatic distance");
                return;
            }
            setDlgkmltocsvvisible(false);
            setlast_edit_corde(edit_corde);
            setlast_edit_width(edit_width.toString());
            setlast_edit_pcdep(edit_pcdep.toString());

            setLoading(true);
            kmltocsv(tempfile, edit_corde, edit_pcdep, edit_width)
                .then((answer: APIAnswerData) => 
                {
                    if (answer.status)
                    {
                        setUploadFile(answer.data.csv);
                        setlastuploadfile(answer.data.csv);
                    }
                    else
                    {
                        setlastuploadfile("");
                        if (answer.data && answer.data.stdout) message.error(<pre style={{margin:0, whiteSpace:'pre-wrap', textAlign:'left'}}>{answer.data.stdout.join('\n')}</pre>);
                }
                    setShowFile(false);
                    setLoading(false);
                    setTimeout(() => setShowFile(true), 100);
                })
                .catch(error =>
                {
                    message.error("ddd" + error.message);
                    if (error.status === 403 || error.status === 401) navigate('/login');
                });
        }
        else
        {
            setDlgkmltocsvvisible(false);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               computejumps
    \* -------------------------------------------------------------------------------- */
    function computejumps(content: string, distance: number, jumpsave: JumpSave[])
    {
        type JumpInfo = { key: string, type: string, number: number, distance: number, distjump: number };
        const jumps: JumpInfo[] = [];

        let dist_prec = distance;
        const sorted = jumpsave.slice().sort((a, b) => b.distance - a.distance);
        let nojump = sorted.length;
        for (const jump of sorted)
        {
            let dists: number = Math.floor((dist_prec - 15) / 10) * 10;
            if ((dists % 100) === 0) dists -= 10;

            let dista: number = Math.floor((jump.distance + 35) / 10) * 10;
            if ((dista % 100) === 0) dista += 10;

            const jd = Math.floor(jump.distance);

            if (dists - dista >= 40) jumps.push({ key: 'PCS', type: jump.type, number: nojump, distance: dists, distjump: jd });
            if (dist_prec -dista >= 30) jumps.push({ key: 'PCA', type: jump.type, number: nojump, distance: dista, distjump: jd });
            jumps.push({ key: 'PCO', type: jump.type, number: nojump, distance: Math.floor(jump.distance), distjump: jd });

            dist_prec = jump.distance;
            nojump--;
        }

        let keys: string[] = [];
        for (const info of jumps)
        {
            let key: string;

            key = info.key + String(info.number).padStart(2, '0') + info.type + String(info.key === 'PCA' ? info.distance : info.distjump);
            keys.push(key + ':' + String(info.distance));
        }

        setLoading(true);
        addkeys(content, keys.join(','))
            .then((answer: APIAnswerData) => 
            {
                if (answer.status)
                {
                    setUploadFile(answer.data.content);
                }
                else
                {
                    if (answer.data && answer.data.stdout) message.error(<pre style={{margin:0, whiteSpace:'pre-wrap', textAlign:'left'}}>{answer.data.stdout.join('\n')}</pre>);
                }
            })
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            })
            .finally(() => setLoading(false));
    }
    /* -------------------------------------------------------------------------------- *\
    |                               editjump
    \* -------------------------------------------------------------------------------- */
    function editjump(jump: JumpInfos) : void
    {
        setEditDistance(jump.distance);
        setEditJump(JUMPS.find((j: JumpType) => j.key === jump.key) || JUMPS[0]);
        setSelectEditJump(jump);
        setDlgjumpvisible(true);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               addjump
    \* -------------------------------------------------------------------------------- */
    function addjump()
    {
        setEditDistance(1000);
        setEditJump(JUMPS[0]);
        setSelectEditJump(null);
        setDlgjumpvisible(true);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               removejump
    \* -------------------------------------------------------------------------------- */
    function removejump(jump: JumpInfos)
    {
        setJumpsInfos(jumpsinfos.filter((j: JumpInfos) => j !== jump));
    }
    /* -------------------------------------------------------------------------------- *\
    |                               updatejumps
    \* -------------------------------------------------------------------------------- */
    function updatejumps()
    {
        if (!trackinfos)
        {
            message.error("You must load a track first");
            return;
        }
        let dist_prec: number = 0;

        let content: string = uploadfile;
        const lines = content.replace(/\r/g, '').split("\n");
        content = '';
        var first: boolean = true;
        for (const line of lines)
        {
            if (!first && line)
            {
                const els = line.split(";");
                if (els.length >= 8)
                {
                    if (els[7] !== 'PCARR')
                    {
                        if (els[7].startsWith("PCS") || els[7].startsWith("PCA") || els[7].startsWith("PCO"))
                        {
                            els[7] = '0';
                        }
                    }
                    content += els.join(";") + "\n";
                    if (els[7] === 'PCDEP') dist_prec = Number(els[0]);
                }
            }
            if (first) content += line + "\n";
            first = false;
        }
        const jumps: JumpSave[] = computejumpsave();
        computejumps(content, dist_prec, jumps);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               dlgeditjumpclose
    \* -------------------------------------------------------------------------------- */
    function dlgeditjumpclose(save: boolean)
    {
        if (save)
        {
            if (selectedit_jump)
            {
                selectedit_jump.key = edit_jump.key;
                selectedit_jump.text = edit_jump.text;
                selectedit_jump.distance = edit_distance;
                setJumpsInfos(jumpsinfos.map((j: JumpInfos) => j === selectedit_jump ? selectedit_jump : j));
            }
            else
            {
                var jump = new JumpInfos();
                jump.distance = edit_distance;
                jump.key = edit_jump.key;
                jump.number = jumpsinfos.length + 1;
                jump.text = edit_jump.text;
                setJumpsInfos([...jumpsinfos, jump]);
            }
        }
        setDlgjumpvisible(false);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() =>
    {
        changetrack();
    // eslint-disable-next-line
    }, [uploadfile]);
    useEffect(() =>
    {
        /* -------------------------------------------------------------------------------- *\
        |                               addpolyline
        \* -------------------------------------------------------------------------------- */
        function addpolyline(path: google.maps.LatLngLiteral[], color: string) : google.maps.Polyline
        {
            const polyline = new google.maps.Polyline({
                path: path,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 1.0,
                strokeWeight: 1
            });
            polyline.setMap(map);
            return polyline;
        }
        if (!map) return;

        setLoading(true);
        var marks_int: ReactElement[] = [];
        var marks_mid: ReactElement[] = [];
        var marks_ext: ReactElement[] = [];
        var lines: google.maps.Polyline[] = [];

        const icon_size = 10;
        const gsize = new window.google.maps.Size(icon_size, icon_size);
        const ganchor = new google.maps.Point(icon_size / 2, icon_size / 2);

        var index: number = 0;
        for(const pt of mappoints)
        {
            const pos_int = { lat: pt.lat_int, lng: pt.lon_int };
            const pos_mid = { lat: pt.lat_mid, lng: pt.lon_mid };
            const pos_ext = { lat: pt.lat_ext, lng: pt.lon_ext };
            if ((pt.extra === 'PCDEP' || pt.extra === 'PCARR') || (Number(pt.extra) !== 0 && !pt.extra.startsWith('PY') && parseInt(pt.extra.slice(2))))
            {
                marks_int.push(
                    <Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/green_dot.png`, scaledSize: gsize, anchor: ganchor}}>
                        <div>{pt.extra}</div>
                        {
                            showgate &&
                            <InfoWindowF position={pos_int}><div style={{color: 'black'}}>{pt.extra}</div></InfoWindowF>
                        }
                    </Marker>
                );
                lines.push(addpolyline([ pos_int, pos_ext ], '#pink'));

                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/green_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            else if (pt.extra.startsWith("PCO"))
            {
                marks_int.push(
                    <Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/pink_dot.png`, scaledSize: gsize, anchor: ganchor}}>
                        <div>{pt.extra}</div>
                        {
                            showobstacle &&
                            <InfoWindowF position={pos_int}><div style={{color: 'black'}}>{pt.extra}</div></InfoWindowF>
                        }
                    </Marker>
                );
                lines.push(addpolyline([ pos_int, pos_ext ], '#FF00B6'));
                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/pink_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            else if (pt.extra.startsWith("PY"))
            {
                marks_int.push(
                    <Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/purple_dot.png`, scaledSize: gsize, anchor: ganchor}}>
                        <div>{pt.extra}</div>
                        {
                            showyards &&
                            <InfoWindowF position={pos_int}><div style={{color: 'black'}}>{pt.extra}</div></InfoWindowF>
                        }
                    </Marker>
                );
                lines.push(addpolyline([ pos_int, pos_ext ], '#FAFF00'));
                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/purple_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            else
            {
                marks_int.push(<Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/blue_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/red_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            index++;
        }
        setMarkers_int(marks_int);
        setMarkers_mid(marks_mid);
        setMarkers_ext(marks_ext);
        setMapLines(lines);
        setLoading(false);
    }, [mappoints, showgate, showobstacle, showyards, showmids, map])
    useEffect(() =>
    {
        function addgate(marks: ReactElement[],pc: TrackPoint, color: string)
        {
            const gsize = new window.google.maps.Size(icon_size, icon_size);
            const ganchor = new google.maps.Point(icon_size / 2, icon_size / 2);
            const pos_int = { lat: pc.lat_int, lng: pc.lon_int };
            const pos_ext = { lat: pc.lat_ext, lng: pc.lon_ext };
            marks.push(<Marker key={`marker_selpc1_${color}`} position={pos_int} icon={{ url: `/images/${color}_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            marks.push(<Marker key={`marker_selpc2_${color}`} position={pos_ext} icon={{ url: `/images/${color}_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
        }
        var marks: ReactElement[] = [];
        const icon_size = 20;
        if (selectedpc)
        {
            addgate(marks, selectedpc, 'white');

        }
        if (selectedit_jump && selectedit_jump.pca)
        {
            addgate(marks, selectedit_jump.pca, 'yellow');
        }
        if (selectedit_jump && selectedit_jump.pcs)
        {
            addgate(marks, selectedit_jump.pcs, 'orange');
        }
        setMarkersSelectedPC(marks);
    }, [selectedpc, selectedit_jump])
    useEffect(() =>
    {
        if (follow && selectedpc)
        {
            const pt = { lat: (selectedpc.lat_int + selectedpc.lat_int) / 2, lng: (selectedpc.lon_int + selectedpc.lon_int) / 2 };
            setCenter(pt);
        }
    }, [follow, selectedpc])

    const [center, setCenter] = useState(MAP_CENTER);
    const zoom = MAP_ZOOM;
    const options = MAP_OPTIONS;

    const [mapwidth] = useState(MAP_STYLE.width);
    const [mapheight] = useState(MAP_STYLE.height);

    return (
        <LayoutSite>
            <div className="edittrack">
                {loading ? <Loader /> : <></>}
                <div className="edittrack__header">
                    <div>Edit track</div>
                </div>
                <div className="edittrack__body">
                    <div className="edittrack__body__title">
                        <Button size="small" onClick={() => loadcsv()}>Load csv</Button>
                        <Button size="small" onClick={() => loadkml()}>Load KML</Button>
                        <Button size="small" onClick={() => loadjumps()}>Load jumps</Button>
                        <Button size="small" onClick={() => getcsv()}>Get csv</Button>
                        <Button size="small" onClick={() => getkml()}>Get KML</Button>
                        {
                            showfile &&
                            <Input id="inputfile" className="edittrack__nodisplay" type="file" onChange={(e) => {if (e.target.files) handleuploadfile(e.target.files)}}/>
                        }
                    </div>
                    <div style={currentcsv ? {} : { display: 'none' }}>
                        <div className="edittrack__body__track">
                            <div className='edittrack__body__track__infos'>
                                <div className='edittrack__body__track__infos__line'>
                                    <div className='edittrack__body__track__infos__line__label'>PCDEP distance</div>
                                    <div className='edittrack__body__track__infos__line__value'>{trackinfos?.dist_pcdep}</div>
                                </div>
                                <div className='edittrack__body__track__infos__line'>
                                    <div className='edittrack__body__track__infos__line__label'>Total distance</div>
                                    <div className='edittrack__body__track__infos__line__value'>{trackinfos?.dist_total}</div>
                                </div>
                                <div className='edittrack__body__track__infos__line'>
                                    <div className='edittrack__body__track__infos__line__label'>Yards</div>
                                    <div className='edittrack__body__track__infos__line__value'>{trackinfos?.withyards ? 'Yes' : 'No'}</div>
                                </div>
                                <div className='edittrack__body__track__infos__line'>
                                    <div className='edittrack__body__track__infos__line__label'>Jumps</div>
                                    <div className='edittrack__body__track__infos__line__value'>{trackinfos?.jumps.length}</div>
                                </div>
                            </div>
                            <div className='edittrack__body__track__pcs'>
                            {
                                mappc.map((pc,i) => 
                                {
                                    let c = pc === selectedpc ? ' edittrack__body__track__pcs__line__active' : '';
                                    if (!c) c = pc === selectedit_jump?.pcs ? ' edittrack__body__track__pcs__line__mark1' : '';
                                    if (!c) c = pc === selectedit_jump?.pca ? ' edittrack__body__track__pcs__line__mark2' : '';
                                    return (
                                        <div key={'pc_' + i} id={'mappc_' + i}>
                                            <Tooltip title={pc.distance + "m"} placement="right">
                                                <div className={'edittrack__body__track__pcs__line' + c} onClick={n => { doselectpc(pc); }}>
                                                    {pc.extra}
                                                </div>
                                            </Tooltip>
                                        </div>
                                    )
                                })
                            }
                            </div>
                            <div className='edittrack__body__track__map'>
                                <div className="edittrack__body__track__map__tools">
                                    <Switch size="small" onChange={(e) => {setShowGate(!showgate);}} checked={showgate}/>
                                    <div>Afficher les gates</div>
                                    <Switch size="small" onChange={(e) => {setShowObstacle(!showobstacle);}} checked={showobstacle}/>
                                    <div>Afficher les obstacles</div>
                                    <Switch size="small" onChange={(e) => {setShowYards(!showyards);}} checked={showyards}/>
                                    <div>Afficher les yards</div>
                                    <Switch size="small" onChange={(e) => {setShowMids(!showmids);}} checked={showmids}/>
                                    <div>Afficher la ligne 1m</div>
                                    <Switch size="small" onChange={(e) => {setFollow(!follow);}} checked={follow}/>
                                    <div>follow</div>
                                </div>
                                <LoadScript googleMapsApiKey={API_KEY} >
                                    <GoogleMap
                                        id='themap'
                                        onLoad={(map) => setMap(map)}
                                        mapContainerStyle={{ width: mapwidth, height: mapheight }}
                                        zoom={zoom}
                                        center={center}
                                        options={options}>
                                        { markers_int }
                                        { showmids ? markers_mid : <></> }
                                        { markers_ext }
                                        { markers_selpc }
                                    </GoogleMap>
                                </LoadScript>
                            </div>
                            {
                                <div className='edittrack__body__track__jumps'>
                                    <div className='edittrack__body__track__jumps__title'>Jumps</div>
                                    <div className='edittrack__body__track__jumps__button'>
                                        <Button size="small" onClick={() => { addjump(); }}>Add jump</Button>
                                        <Button size="small" disabled={jumpsinfos.length === 0} onClick={() => getjumps()}>Save jumps</Button>
                                        <Button size="small" onClick={() => { updatejumps();}}>Update track</Button>
                                    </div>
                                    <div className='edittrack__body__track__jumps__jump'>
                                        <div className='edittrack__body__track__jumps__jump__element'>#</div>
                                        <div className='edittrack__body__track__jumps__jump__element'>dist.</div>
                                        <div className='edittrack__body__track__jumps__jump__element'>key</div>
                                        <div className='edittrack__body__track__jumps__jump__element'>text</div>
                                    </div>                                        
                                    {
                                        jumpsinfos.map((j: JumpInfos, i: number) => 
                                        {
                                            var selected = selectedpc && j.position && j.position.extra === selectedpc.extra;
                                            
                                            return (
                                            <div className={'edittrack__body__track__jumps__jump' + (selected ? ' edittrack__body__track__jumps__jump__active' : '')} key={'jump_' + i}>
                                                <div className='edittrack__body__track__jumps__jump__element edittrack__body__track__jumps__jump__element__button' onClick={() => { changeselectedjump(j); }}>{j.number}</div>
                                                <div className='edittrack__body__track__jumps__jump__element'>{j.distance}</div>
                                                <div className='edittrack__body__track__jumps__jump__element'>{j.key}</div>
                                                <div className='edittrack__body__track__jumps__jump__element'>{j.text}</div>
                                                <div className='edittrack__body__track__jumps__jump__element'><Button size="small" onClick={() => { editjump(j); }}>Edit</Button></div>
                                                <div className='edittrack__body__track__jumps__jump__element'><Button size="small" onClick={() => { removejump(j); }}>Remove</Button></div>
                                            </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {
                    dlgkmltocsvvisible &&
                    <Modal className='edittrack__modal' maskClosable={false} title={"Load KML"} open={dlgkmltocsvvisible} onOk={() => dlgeditvenueclose(true)} onCancel={() => dlgeditvenueclose(false)}>
                        <EditInfos type="number" label="PCDep (0=auto)" value={edit_pcdep} onChange={(v) => { setEditPCDep(v as number) }} />
                        <EditInfos type="number" label="Width" value={edit_width} onChange={(v) => { setEditWidth(v as number) }} />
                        <div className="race__editvalue">
                            <div className="race__editvalue__label">corde</div>
                            <Select value={edit_corde} onChange={(v) => { setEditCorde(v) }} style={{ width: 100 }}>
                                <Select.Option value="gauche">Left</Select.Option>
                                <Select.Option value="droite">Right</Select.Option>
                            </Select>
                        </div>
                        {
                            showfile &&
                            <EditInfos type="file" label="file" value='' onChange={(v) => { handleuploadfile(v as FileList); }} />
                        }
                    </Modal>
                }
                {
                    dlgjumpvisible &&
                    <Modal className='edittrack__modal' maskClosable={false} title={selectedit_jump ? "Edit jump" : "Add jump"} open={dlgjumpvisible} onOk={() => dlgeditjumpclose(true)} onCancel={() => dlgeditjumpclose(false)}>
                        <EditInfos type="number" label="distance" value={edit_distance} onChange={(v) => { setEditDistance(v as number) }} />
                        <div className="race__editvalue">
                            <div className="race__editvalue__label">code</div>
                            <Select className='edittrack__modal__select' value={edit_jump.key} onChange={(v) => { setEditJump(JUMPS.find(j => j.key === v) || JUMPS[0]) }} style={{ width: 100 }}>
                                {
                                    Array.from(new Map(JUMPS.map(j => [j.key, j])).values())
                                        .sort((a,b) => a.key.localeCompare(b.key))
                                        .map(j => <Select.Option key={j.key} value={j.key}>{j.text}</Select.Option>)
                                }
                            </Select>
                        </div>
                    </Modal>
                }
            </div>
        </LayoutSite>
    );
}
